import React, { useState } from "react";
import { cn } from "../../../../lib/utils";

import { useAppContext } from "../../../../context/AppContext";
import DoorColourRadiogroup from "./DoorColourRadiogroup";

import { Input } from "../../ui/Input";
import {
    FormControl,
    FormField,
    FormItem,
    FormLabel,
    FormMessage,
} from "../../ui/Form";
import ColourTypeTabs from "../tab/ColourTypeTabs";
const InternalDoorColour = ({ methods, isOpen: { InternalDoorColour }, input_name, name, oxide }) => {
    const {
        state: { selectedInternalColourType, selectedInternalSlabColourType },
        setSelectedInternalColourType,
        setSelectedInternalSlabColourType,
    } = useAppContext();

    // Determine current colour type based on section name
    const currentColourType = name === "Internal Panel Colour" ? selectedInternalSlabColourType : selectedInternalColourType;

    const {
        setValue,
        register,
        formState: { errors },
        control,
    } = methods;

    return (
        <div
            className={cn(
                "section flex flex-col gap-6 transition-all opacity-0 h-0 ",
                {
                    ["h-full opacity-100"]: InternalDoorColour.isOpen,
                }
            )}
        >
            <ColourTypeTabs setValue={setValue} oxide={oxide} view="internal" name={name} input_name={input_name} />
            {currentColourType === 'oxide' &&
            <p className='text-primary mb-0 underline'>
                Oxide Range
            </p>
            }
            <div className="flex flex-wrap [&>div]:max-w-1/4 gap-4 ">
                <DoorColourRadiogroup
                    {...methods}
                    type={currentColourType}
                    view="internal"
                    oxide={oxide}
                    input_name={input_name}
                />
            </div>
            <div className="flex flex-col gap-2">
                <FormField
                    control={control}
                    name="internal_custom_ral_color"
                    render={({ field }) => (
                        <FormItem>
                            <FormLabel className="text-gray-700">
                                Custom Ral Colour
                            </FormLabel>
                            <FormControl>
                                <Input
                                    type="text"
                                    icon
                                    className="text-gray-700"
                                    placeholder="Enter Ral Colour"
                                    {...field}
                                />
                            </FormControl>
                            {errors.internal_custom_ral_color && (
                                <FormMessage>
                                    {errors.internal_custom_ral_color.message}
                                </FormMessage>
                            )}
                        </FormItem>
                    )}
                />
            </div>
        </div>
    );
};

export default InternalDoorColour;
